<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters>
      <i-page-title title="fileUpload" />
      <v-col cols="12" sm="12" lg="12" class="pa-2">
        <i-card-top
          class="d-md-flex"
          :useBtnList="buttonUseList"
          @btnAdd="btnAdd()"
          @btnSearch="btnSearch()"
          @btnSave="btnSave()"
          @btnDelete="btnDelete()"
        >
          <template v-slot:body>
            <v-layout>
              <v-row no-gutters class="pa-2 pb-0">
                <v-col cols="12" md="3" class="py-2 py-md-0">
                  <v-text-field
                    v-model="targetType"
                    label="타겟타입"
                    class="mx-1 rounded-0"
                    dense
                    outlined
                    hide-details="auto"
                    :prepend-inner-icon="$t('$search')"
                    @keydown.enter="btnSearch()"
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="targetId"
                    label="타겟아이디"
                    class="mx-1 rounded-0"
                    dense
                    outlined
                    hide-details="auto"
                    :prepend-inner-icon="$t('$search')"
                    @keydown.enter="btnSearch()"
                    clearable
                  />
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-top>
        <i-card-vertical headerTitle="파일업로드">
          <template v-slot:body>
            <v-layout column overflow-auto>
              <div class="widget-container flex-box">
                <span>Profile Picture</span>
                <div
                  id="dropzone-external"
                  class="flex-box"
                  :class="[isDropZoneActive ? 'dx-theme-accent-as-border-color dropzone-active' : 'dx-theme-border-color']"
                >
                  <img id="dropzone-image" :src="imageSource" v-if="imageSource" alt="" />
                  <div id="dropzone-text" class="flex-box" v-if="textVisible">
                    <span>Drag & Drop the desired file</span>
                    <span>…or click to browse for a file instead.</span>
                  </div>
                  <DxProgressBar
                    id="upload-progress"
                    :min="0"
                    :max="100"
                    width="30%"
                    :show-status="false"
                    :visible="progressVisible"
                    :value="progressValue"
                  />
                </div>
                <DxFileUploader
                  id="file-uploader"
                  dialog-trigger="#dropzone-external"
                  drop-zone="#dropzone-external"
                  :multiple="false"
                  :allowed-file-extensions="allowedFileExtensions"
                  upload-mode="useButtons"
                  :visible="false"
                  upload-url="/api/file/imUpload?desc="
                  @drop-zone-enter="onDropZoneEnter"
                  @drop-zone-leave="onDropZoneLeave"
                  @uploaded="onUploaded"
                  @progress="onProgress"
                  @upload-started="onUploadStarted"
                  @value-changed="onValueChanged"
                  :upload-custom-data="uploaderCustomData"
                />
              </div>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import iPageTitle from '@/components/common/iPageTitle.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import { DxFileUploader } from 'devextreme-vue/file-uploader'
import { DxProgressBar } from 'devextreme-vue/progress-bar'
import notify from 'devextreme/ui/notify'
import iCardTop from '@/components/common/iCardTop.vue'
import { multiUpload, imageFileTest } from '@/api/baseManage/fileUpload'

import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'groupManage',
  components: {
    DxFileUploader,
    DxProgressBar,
    'i-page-title': iPageTitle,
    'i-card-vertical': iCardVertical,
    'i-card-top': iCardTop
  },
  data() {
    return {
      isDropZoneActive: false,
      imageSource: '',
      textVisible: true,
      progressVisible: false,
      progressValue: 0,
      allowedFileExtensions: ['.jpg', '.jpeg', '.gif', '.png'],
      fileData: null,
      uploaderCustomData: { targetType: this.targetType, targetId: this.targetId },
      targetType: '',
      targetId: '',
      files: [],
      allMode: 'allPages',
      buttonUseList: [
        'btnSearch', //조회
        'btnAdd', //추가
        'btnSave', //저장
        'btnDelete' //삭제
      ]
    }
  },
  methods: {
    btnSearch() {
      let params = { targetType: this.targetType, targetId: this.targetId, compId: this.comp.id }
      imageFileTest(params).then(res => {
        var file = new File([res], 'name')

        const fileReader = new FileReader()

        fileReader.onload = () => {
          this.isDropZoneActive = false
          this.imageSource = fileReader.result
        }
        fileReader.readAsDataURL(file)

        this.textVisible = false
        this.progressVisible = false
        this.progressValue = 0
      })
    },
    btnSave() {
      this.$vToastify
        .prompt({
          body: '이미지를 저장하시겠습니까?',
          answers: { Yes: true, No: false }
        })
        .then(value => {
          if (!value) return
          else {
            var formData = new FormData()

            formData.append('files[]', this.fileData)

            let fileVO = {
              fileId: null,
              targetId: this.targetId,
              targetType: this.targetType,
              useYn: this.useYn,
              compId: this.comp.id
            }
            formData.append('FileVO', new Blob([JSON.stringify(fileVO)], { type: 'application/json' }))

            multiUpload(formData, true)
              .then(res => {
                if (res.success) {
                  console.log('성공!')
                } else {
                  this.$vToastify.error({ body: res.msg })
                }
              })
              .catch(error => {})
              .finally(() => {})
          }
        })
    },
    btnDelete() {
      this.imageSource = ''
      this.textVisible = true
    },
    onDropZoneEnter(e) {
      if (e.dropZoneElement.id === 'dropzone-external') {
        this.isDropZoneActive = true
      }
    },
    onDropZoneLeave(e) {
      if (e.dropZoneElement.id === 'dropzone-external') {
        this.isDropZoneActive = false
      }
    },
    onUploaded(e) {
      const { file } = e
      const fileReader = new FileReader()
      fileReader.onload = () => {
        this.isDropZoneActive = false
        this.imageSource = fileReader.result
      }
      fileReader.readAsDataURL(file)
      this.textVisible = false
      this.progressVisible = false
      this.progressValue = 0
      notify(this.$t('파일이 업로드 되었습니다.'), 'success', 300)
    },
    onProgress(e) {
      this.progressValue = (e.bytesLoaded / e.bytesTotal) * 100
    },
    onUploadStarted(e) {
      console.log(this.uploaderCustomData)
      this.imageSource = ''
      this.progressVisible = true
    },
    onValueChanged(e) {
      this.uploaderCustomData = { targetType: this.targetType, targetId: this.targetId }
      const fileReader = new FileReader()

      fileReader.onload = () => {
        this.isDropZoneActive = false
        this.imageSource = fileReader.result
      }
      fileReader.readAsDataURL(e.value[0])

      this.textVisible = false
      this.progressVisible = false
      this.progressValue = 0
      this.fileData = e.value[0]
    }
  }
}
</script>

<style>
#dropzone-external {
  width: 350px;
  height: 350px;
  background-color: rgba(183, 183, 183, 0.1);
  border-width: 2px;
  border-style: dashed;
  padding: 10px;
}

#dropzone-external > * {
  pointer-events: none;
}

#dropzone-external.dropzone-active {
  border-style: solid;
}

.widget-container > span {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 16px;
}

#dropzone-image {
  max-width: 100%;
  max-height: 100%;
}

#dropzone-text > span {
  font-weight: 100;
  opacity: 0.5;
}

#upload-progress {
  display: flex;
  margin-top: 10px;
}

.flex-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.widget-container {
  margin-right: 320px;
}

.contents h4 {
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 18px;
}

.contents {
  margin-top: 50px;
  margin-left: 10px;
  display: none;
}

.fileList {
  padding: 10px;
  width: 400px;
  background-color: rgba(183, 183, 183, 0.1);
}

.fileNm {
  height: 20px;
  font-weight: bold;
}

.fileList > .fileSize {
  height: 20px;
  font-size: 12px;
}
</style>
